<template>
    <div class="form-group">
        <!-- start upload image area -->
        <div class="form-group">
            <label for="image">Selfie Dengan KTP / SIM</label>
            <button class="btn btn-sm btn-plain text-danger" v-if="previewImageSelfie !== ''" @click="previewImageSelfie = ''">
                <i class="bi-x-circle"></i> Remove Image
            </button>
            <div class="my-2 text-center preview-image" v-if="previewImageSelfie !== ''">
                <img class="img-fluid rounded" style="max-height: 200px;" :src="previewImageSelfie" alt="Uploaded Image">
            </div>
            <div
                v-if="isUploading && mode === 'selfie' && previewImageSelfie === ''"
                class="pc-image-empty"
            >
                <div class="image-loading">
                    <div class="is-loading"></div>
                </div>
            </div>
            <div
                v-else-if="previewImageSelfie === ''"
                class="pc-image-empty cursor-pointer"
                @click="uploadImage('selfie')"
            >
                <div class="image-upload-placeholder">
                    <i class="fi fi-rr-picture image-placeholder"></i>
                    <div class="text-placeholder">
                        Klik untuk upload.
                    </div>
					<div class="pc-input-desc">
						Maximum image size adalah 3MB
					</div>
                </div>
            </div>
            <div class="pc-input-desc text-danger" v-if="previewImageSelfieError !== ''" v-html="this.sanitizeHtml(previewImageSelfieError)"></div>
        </div>
		<div class="form-group">
            <label for="image">KTP / SIM</label>
            <button class="btn btn-sm btn-plain text-danger" v-if="previewImageFull !== ''" @click="previewImageFull = ''">
                <i class="bi-x-circle"></i> Remove Image
            </button>
            <div class="my-2 text-center preview-image" v-if="previewImageFull !== ''">
                <img class="img-fluid rounded" style="max-height: 200px;" :src="previewImageFull" alt="Uploaded Image">
            </div>
            <div
                v-if="isUploading && mode === 'full' && previewImageFull === ''"
                class="pc-image-empty"
            >
                <div class="image-loading">
                    <div class="is-loading"></div>
                </div>
            </div>
            <div
                v-else-if="previewImageFull === ''"
                class="pc-image-empty cursor-pointer"
                @click="uploadImage('full')"
            >
                <div class="image-upload-placeholder">
                    <i class="fi fi-rr-picture image-placeholder"></i>
                    <div class="text-placeholder">
                        Klik untuk upload.
                    </div>
					<div class="pc-input-desc">
						Maximum image size adalah 3MB
					</div>
                </div>
            </div>
            <div class="pc-input-desc text-danger" v-if="previewImageFullError !== ''" v-html="this.sanitizeHtml(previewImageFullError)"></div>
        </div>
        <div class="form-group buttons m-0 hidden">
            <input
                type="file"
                accept="image/*"
                class="input-file"
                ref="imageUploader"
                id="pc-product-images-file"
                @change="onInputImageChange"
                multiple
            />
            <label
                for="pc-product-images-file"
                class="btn btn-primary"
                :class="{ 'is-loading': isUploading }"
                >Upload images</label
            >
            <div class="pc-input-desc">
                Make sure your image resolution is 1296x324 px
            </div>
        </div>
        <!-- end upload image area -->
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { getAxiosErrorValidation, sanitizeHtml } from '@/lib/helper';
import mediaApi from '@/api/media';

export default {
	name: 'UploadIdentity',
	data() {
		return {
			previewImageSelfie: '',
			previewImageFull: '',
			previewImageSelfieError: '',
			previewImageFullError: '',
			isUploading: false,
			isSavingIdentity: false,
			mode: 'selfie',
		};
	},
	methods: {
		...mapActions({
			addIdentityCard: 'addIdentityCard',
		}),
		uploadImage(mode) {
			this.mode = mode;
			const inputFile = this.$refs.imageUploader;
			inputFile.click();
		},
		onInputImageChange(event) {
			this.isUploading = true;
			this.setPreviewImageError('');
			const maxUploadSize = 3; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `Image '${image.name}' size is too large (max 3MB)`;
					this.setPreviewImageError(noticeMessage);
					this.$notify({
						group: 'app',
						text: noticeMessage,
						type: 'error',
					});
					this.isUploading = false;
					break;
				}

				this.setPreviewImage('');

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('image', image);

				const callback = (response) => {
					this.isUploading = false;
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;

					this.setPreviewImage(url);
					this.updateIdentityCard('requested');
				};

				const errorCallback = (e) => {
					this.isUploading = false;
					const validations = getAxiosErrorValidation(e);

					let noticeMessage = 'Image';

					if (validations.image !== undefined) {
						validations.image.forEach((key) => {
							if (key === 'validation.mimes') {
								noticeMessage += ' type is not allowed <br>';
							}
							if (key === 'validation.max.file') {
								noticeMessage += ' size too large max (3MB) <br>';
							}
						});

						this.setPreviewImageError(noticeMessage);
						this.$notify({
							group: 'app',
							text: noticeMessage,
							type: 'error',
						});
					}
				};

				// Upload Image
				mediaApi.uploadImage(uploadParams, callback, errorCallback);
			}
			event.target.files = null;
			event.target.value = '';
		},
		setPreviewImage(value) {
			if (this.mode === 'selfie') {
				this.previewImageSelfie = value;
			} else if (this.mode === 'full') {
				this.previewImageFull = value;
			}
		},
		setPreviewImageError(value) {
			if (this.mode === 'selfie') {
				this.previewImageSelfieError = value;
			} else if (this.mode === 'full') {
				this.previewImageFullError = value;
			}
		},
		updateIdentityCard(status) {
			this.isSavingIdentity = true;
			const identity = this.identityCard;
			identity.image_url = this.previewImageSelfie;
			identity.image_url_full = this.previewImageFull;
			identity.status = status;
			const cb = () => {
				this.isSavingIdentity = false;
			};
			const errorCb = () => {
				this.isSavingIdentity = false;
			};
			this.addIdentityCard({ identity, cb, errorCb });
		},
		sanitizeHtml,
	},
	computed: {
		...mapGetters({
			user: 'user',
			identityCard: 'identityCard',
		}),
	},
	mounted() {
		if (this.identityCard !== null) {
			this.previewImageSelfie = this.identityCard.image_url;
			this.previewImageFull = this.identityCard.image_url_full;
		}
	},
	watch: {
		isSavingIdentity(val) {
			this.$emit('uploaded', val);
		},
	},
};
</script>
